import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {  Router, Route, Routes, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import './css/App.css';
import About from './components/About';
import Register from './components/Register';
import Login from './components/login';
import Dashboard from './components/Dashboard';
import SubmitMission from './components/SubmitMission';
import ManageMissions from './components/ManageMissions';
import ViewMission from './components/ViewMission';
import ManageProfiles from './components/ManageProfiles';
import ViewProfil from './components/ViewProfil';
import SubmitProfil from './components/SubmitProfil';
import ManageUsers from './components/ManageUsers';
import AddUser from './components/AddUser';
import EditUser from './components/EditUser';
import UserProfile from './components/UserProfile';
import AvailableMissions from './components/AvailableMissions';
import NotFoundPage from './components/404Page';
import ResetPassword from './components/ResetPassword';
import RequestResetPassword from './components/RequestResetPassword';
import AvailableProfiles from './components/AvailableProfiles';
import ManageCompanies from './components/ManageCompanies';
import AddCompany from './components/AddCompany';
import EditCompany from './components/EditCompany';
import CompanyDetails from './components/CompanyDetails';
import AjouterCv from './components/AjouterCv';
import MesCvs from './components/MesCvs';
import ProtectedRoute from './components/ProtectedRoute'; // ✅ Ton nouveau composant

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('authToken'));

  return (
        <div className="app-container">

        <Navbar isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/register" element={<Register />} />
          <Route path="/missions-list" element={<AvailableMissions />} />
          <Route path="/profils-liste" element={<AvailableProfiles />} />
          <Route path="/reset-password" element={<RequestResetPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />

          {/* ✅ Routes protégées */}
          <Route path="/dashboard" element={
            <ProtectedRoute><Dashboard setIsAuthenticated={setIsAuthenticated} /></ProtectedRoute>
          } />
          <Route path="/submit-mission" element={
            <ProtectedRoute><SubmitMission /></ProtectedRoute>
          } />
          <Route path="/submit-profil" element={
            <ProtectedRoute><SubmitProfil /></ProtectedRoute>
          } />
          <Route path="/missions" element={
            <ProtectedRoute><ManageMissions /></ProtectedRoute>
          } />
          <Route path="/missions/:id" element={
            <ProtectedRoute><ViewMission /></ProtectedRoute>
          } />
          <Route path="/profils" element={
            <ProtectedRoute><ManageProfiles /></ProtectedRoute>
          } />
          <Route path="/profils/:id" element={
            <ProtectedRoute><ViewProfil /></ProtectedRoute>
          } />
          <Route path="/manage-users" element={
            <ProtectedRoute><ManageUsers /></ProtectedRoute>
          } />
          <Route path="/add-user" element={
            <ProtectedRoute><AddUser /></ProtectedRoute>
          } />
          <Route path="/edit-user/:id" element={
            <ProtectedRoute><EditUser /></ProtectedRoute>
          } />
          <Route path="/manage-companies" element={
            <ProtectedRoute><ManageCompanies /></ProtectedRoute>
          } />
          <Route path="/add-company" element={
            <ProtectedRoute><AddCompany /></ProtectedRoute>
          } />
          <Route path="/edit-company/:id" element={
            <ProtectedRoute><EditCompany /></ProtectedRoute>
          } />
          <Route path="/company-details/:id" element={
            <ProtectedRoute><CompanyDetails /></ProtectedRoute>
          } />
          <Route path="/ajouter-cv" element={
            <ProtectedRoute><AjouterCv /></ProtectedRoute>
          } />
          <Route path="/mes-cvs" element={
            <ProtectedRoute><MesCvs /></ProtectedRoute>
          } />
          <Route path="/profile" element={
            <ProtectedRoute><UserProfile /></ProtectedRoute>
          } />

          {/* Redirections */}
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer />
      </div>
  );
}

export default App;
